var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFecharJanela(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.355,
    height: 35.355,
    viewBox: "0 0 35.355 35.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(205,45,55)",
    fillRule: "evenodd",
    d: "M25.09590617 7.41823585l2.8411149 2.84111648-7.41827901 7.41827484 7.418318 7.41832216-2.84111649 2.8411149-7.418318-7.41832217-7.418279 7.41827484-2.84111489-2.84111649 7.418279-7.41827484L7.418279 10.25938973l2.84111649-2.8411149 7.41823168 7.41823585 7.418279-7.41827483z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFecharJanela);
export default __webpack_public_path__ + "static/media/fechar_janela.e03cc4588eb4ea8a61281e42f1c99f7b.svg";
export { ForwardRef as ReactComponent };